<template>
    <div class="IperMatrizPeligrosImportarMatriz">
        <div class="text-left">
            <router-link to="/lista_clientes/importar_matriz">
                <button type="button" class="btn boton_guardar1 mt-3 ml-2" :disabled="cargando">
                    Importar Matriz
                </button>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "IperMatrizPeligrosImportarMatriz",

    props: {
        cargando: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped></style>